module.exports = __webpack_public_path__ + "static/media/ls.6497b847.svg";